import { render, staticRenderFns } from "./CopyToSelectInput.vue?vue&type=template&id=696b36d6"
import script from "./CopyToSelectInput.vue?vue&type=script&lang=js"
export * from "./CopyToSelectInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports